module.exports = "/assets/data/f6b21d8df442f2c96351935a85d0dbbe-HX1.data.json";